module.exports = __webpack_public_path__ + "img/KLNG_Cover.15a99291.jpg";